import type { LocationQuery } from 'vue-router'

export function googleCallbackResult(query: LocationQuery): 'linked' | 'failed' | null {
  if (Object.keys(query).length !== 3 || query.oauth !== 'google') return null
  if (query.result !== 'linked' && query.result !== 'failed') return null
  if (
    typeof query.correlationGUID !== 'string' ||
    !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(query.correlationGUID)
  )
    return null

  return query.result
}

export function isGoogleCallbackRoute(route: {
  name?: unknown
  path: string
  meta: Record<string, unknown>
}) {
  return (
    route.name === 'setup-google-oauth' &&
    route.path === '/setup/google-oauth' &&
    route.meta.publicCallback === 'google'
  )
}

export function isGoogleCallbackPath(path: string) {
  return path === '/setup/google-oauth'
}
